const updates = [
  {
    time: '15:42',
    tag: '爆料',
    tagColor: 'bg-primary-100 text-primary-700',
    title: '网友投稿某知名MCN机构内部聊天记录曝光，旗下网红收入分配严重不均',
  },
  {
    time: '14:18',
    tag: '网红',
    tagColor: 'bg-accent-100 text-accent-700',
    title: '某美妆博主直播间试用产品过敏，品牌方紧急下架涉事商品并致歉',
  },
  {
    time: '11:55',
    tag: '娱乐圈',
    tagColor: 'bg-secondary-100 text-secondary-700',
    title: '某热播剧男二号被扒出早年不当言论，剧组官微评论区已沦陷',
  },
  {
    time: '09:30',
    tag: '现场',
    tagColor: 'bg-primary-100 text-primary-700',
    title: '某城市音乐节现场突发设备故障，歌手清唱救场获全场喝彩',
  },
  {
    time: '昨天 22:15',
    tag: '深扒',
    tagColor: 'bg-accent-100 text-accent-700',
    title: '某短视频平台算法被质疑刻意制造对立话题，内部员工匿名爆料',
  },
  {
    time: '昨天 18:40',
    tag: '爆料',
    tagColor: 'bg-primary-100 text-primary-700',
    title: '某亲子类综艺嘉宾私下关系曝光，镜头前后的反差让观众大跌眼镜',
  },
  {
    time: '昨天 16:03',
    tag: '网红',
    tagColor: 'bg-accent-100 text-accent-700',
    title: '某知识类博主涉嫌抄袭海外内容被实锤，连夜删除争议视频并发布道歉',
  },
];

export default function UpdatesSection() {
  return (
    <section id="updates" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-[1200px] mx-auto px-4 md:px-6">
        <div className="flex flex-col sm:flex-row items-start sm:items-end justify-between gap-4 mb-10 md:mb-14">
          <div>
            <span className="inline-block text-xs font-medium text-primary-600 bg-primary-50 px-3 py-1 rounded-full mb-3">
              实时追踪
            </span>
            <h2 className="font-heading font-bold text-2xl md:text-3xl text-foreground-900">
              最新快讯
            </h2>
          </div>
          <span className="text-xs text-foreground-400 flex items-center gap-1">
            <span className="w-2 h-2 rounded-full bg-green-500 inline-block"></span>
            持续更新中
          </span>
        </div>

        <div className="relative pl-8 before:absolute before:left-3 before:top-2 before:bottom-2 before:w-px before:bg-background-300/60">
          {updates.map((item, i) => (
            <div key={i} className="relative pb-6 last:pb-0">
              <div className="absolute -left-[29px] top-1.5 w-2.5 h-2.5 rounded-full bg-primary-500 ring-4 ring-background-50"></div>
              <div className="flex flex-col sm:flex-row sm:items-center gap-2 sm:gap-4">
                <span className="text-xs text-foreground-400 font-medium w-16 shrink-0">{item.time}</span>
                <span className={`text-xs font-medium px-2 py-0.5 rounded-md w-fit whitespace-nowrap ${item.tagColor}`}>
                  {item.tag}
                </span>
                <p className="text-sm text-foreground-700 leading-relaxed flex-1 cursor-pointer hover:text-primary-600 transition-colors">
                  {item.title}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}